import { Log } from '@/logging/datadog';

export type SMSResponseState = 'success' | 'userNotAllowed' | 'offerUsed' | 'error' | 'unknown';

const removeHyphen = (phoneNumber: string) => {
  return phoneNumber.replace(/-/g, '');
};

// TODO: Change message to handle multiple codes.
const formatMessage = (companyName: string, message: string) =>
  `Sýn 2 fyrir 1\n${companyName} \n${message} \nVel gert! Þú hefur virkjað 2f1 tilboð Sýn. \nNjóttu vel!`;

export const handleSendSMS = async (
  phoneNumber: string,
  companyName: string,
  saleInfo: string,
  setState: React.Dispatch<React.SetStateAction<SMSResponseState | null>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  codeQuantity?: number,
  messageText?: string,
  providerCode?: string
) => {
  const number = removeHyphen(phoneNumber);
  const api = `${process.env.NEXT_PUBLIC_VODAFONE_EXPERIENCE_ENDPOINT}/notifications/2for1/sms/${number}`;
  const auth = btoa(process.env.NEXT_PUBLIC_API_USER_NAME + ':' + process.env.NEXT_PUBLIC_API_PASSWORD);
  setLoading(true);
  try {
    const response = await fetch(api, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${auth}`,
      },
      body: JSON.stringify({
        /* NOTE: this may seem odd but is necessary for latest text changes.
        See: https://syn-hf.atlassian.net/browse/VEF-1924 */
        companyName: companyName,
        message: messageText || formatMessage(companyName, saleInfo),
        quantity: codeQuantity || undefined,
        providerCode: providerCode || undefined,
      }),
    });

    if (response.ok) {
      setLoading(false);
      return setState('success');
    } else {
      const responseMessage = await response.text();
      setLoading(false);
      if (response.status === 405 && responseMessage.includes('User has already used the offer')) {
        return setState('offerUsed');
      } else if (response.status === 403 && responseMessage.includes('Number is not Sýn number')) {
        return setState('userNotAllowed');
      }
      return setState('unknown');
    }
  } catch (error) {
    Log.error('Error sending SMS offer:', error);
    setLoading(false);
    return setState('error');
  }
};
